/*
 * Copyright (c) 2022, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */
import { FormattedMessage } from 'react-intl';
import Typography from '@material-ui/core/Typography';
import AuthenticateButton from 'components/ChoreoSystem/Authenticate/AuthenticateButton/AuthenticateButton';
import { ReactComponent as EnterpriseIcon } from 'components/ChoreoSystem/Images/Brands/Enterprise.svg';
import Tooltip from 'components/ChoreoSystem/Tooltip/Tooltip';
import { Box } from '@material-ui/core';
import useStyles from '../style';

interface EnterpriseLoginButtonProps {
  onClick: () => void;
}

export default function EnterpriseLoginButton(
  props: EnterpriseLoginButtonProps
) {
  const { onClick } = props;
  const classes = useStyles();

  const enterpriseBannerTooltipText = (
    <Box className={classes.enterpriseBannerTooltipTextContainer}>
      <Typography className={classes.enterpriseBannerTooltipText}>
        <FormattedMessage
          id="console.navbar.enterprise.banner.tooltip.title"
          defaultMessage={
            'Enable users in your IdP to log in to WSO2 Integration Platform using the Enterprise Login feature. ' +
            'For more information, contact us at devant-help@wso2.com.'
          }
        />
      </Typography>
    </Box>
  );

  return (
    <Tooltip
      title={enterpriseBannerTooltipText}
      arrow
      placement="right-start"
      interactive
    >
      <>
        <AuthenticateButton
          testId="enterprise-sign-in"
          onClick={onClick}
          startIcon={<EnterpriseIcon />}
        >
          <FormattedMessage
            id="authentication.login.button.withEnterprise"
            defaultMessage="Sign in with Enterprise ID"
          />
        </AuthenticateButton>
      </>
    </Tooltip>
  );
}
